"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const plugins_1 = require("../plugins");
const utils_1 = require("../utils");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const browser_tracker_1 = require("@snowplow/browser-tracker");
/**
 * Creates a new Snowplow Tracker
 *
 * @param params all required and optional params for the Tracker initialization
 */
const snowplowTracker = (params) => {
    var _a;
    const enabledPlugins = (0, plugins_1.getEnabledPlugins)(params.pluginConfiguration, (_a = params.googleTagManagerConfiguration) === null || _a === void 0 ? void 0 : _a.enabled);
    const trackerConfig = Object.assign(Object.assign({}, (0, lodash_merge_1.default)(constants_1.DEFAULT_TRACKER_CONFIG, params.trackerConfiguration)), { plugins: (0, plugins_1.getInitializedPlugins)(enabledPlugins) });
    const tracker = (0, browser_tracker_1.newTracker)(constants_1.SNOWPLOW_TRACKER_NAME, params.collectorUrl, Object.assign({ appId: params.appId }, trackerConfig));
    if (typeof window !== 'undefined' &&
        window.snowplow === undefined &&
        tracker !== null &&
        tracker !== undefined) {
        window.snowplow = tracker;
    }
    if (typeof window !== 'undefined' && window.snowplow !== undefined) {
        (0, plugins_1.enablePlugins)(enabledPlugins);
        (0, browser_tracker_1.clearGlobalContexts)();
        (0, utils_1.setGlobalContexts)(params.userType, params.presetGlobalContexts, params.additionalGlobalContexts);
        (0, utils_1.dispatchSnowplowTrackerReadyEvent)();
    }
    else {
        (0, utils_1.dispatchSnowplowTrackerNotReadyEvent)();
    }
    return tracker;
};
exports.default = snowplowTracker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25vd3Bsb3dUcmFja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYWNrZXIvc25vd3Bsb3dUcmFja2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsMkNBQTRFO0FBQzVFLHdDQUFxRjtBQUNyRixvQ0FJa0I7QUFDbEIsZ0VBQWlDO0FBQ2pDLCtEQUE0RTtBQU01RTs7OztHQUlHO0FBQ0gsTUFBTSxlQUFlLEdBQUcsQ0FBQyxNQUE2QixFQUFxQyxFQUFFOztJQUN6RixNQUFNLGNBQWMsR0FBbUIsSUFBQSwyQkFBaUIsRUFDcEQsTUFBTSxDQUFDLG1CQUFtQixFQUMxQixNQUFBLE1BQU0sQ0FBQyw2QkFBNkIsMENBQUUsT0FBTyxDQUNoRCxDQUFDO0lBQ0YsTUFBTSxhQUFhLG1DQUNaLElBQUEsc0JBQUssRUFBQyxrQ0FBc0IsRUFBRSxNQUFNLENBQUMsb0JBQW9CLENBQUMsS0FDN0QsT0FBTyxFQUFFLElBQUEsK0JBQXFCLEVBQUMsY0FBYyxDQUFDLEdBQ2pELENBQUM7SUFFRixNQUFNLE9BQU8sR0FBRyxJQUFBLDRCQUFVLEVBQUMsaUNBQXFCLEVBQUUsTUFBTSxDQUFDLFlBQVksa0JBQ2pFLEtBQUssRUFBRSxNQUFNLENBQUMsS0FBSyxJQUNoQixhQUFhLEVBQ2xCLENBQUM7SUFFSCxJQUNJLE9BQU8sTUFBTSxLQUFLLFdBQVc7UUFDN0IsTUFBTSxDQUFDLFFBQVEsS0FBSyxTQUFTO1FBQzdCLE9BQU8sS0FBSyxJQUFJO1FBQ2hCLE9BQU8sS0FBSyxTQUFTLEVBQ3ZCO1FBQ0UsTUFBTSxDQUFDLFFBQVEsR0FBRyxPQUFPLENBQUM7S0FDN0I7SUFFRCxJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsSUFBSSxNQUFNLENBQUMsUUFBUSxLQUFLLFNBQVMsRUFBRTtRQUNoRSxJQUFBLHVCQUFhLEVBQUMsY0FBYyxDQUFDLENBQUM7UUFDOUIsSUFBQSxxQ0FBbUIsR0FBRSxDQUFDO1FBQ3RCLElBQUEseUJBQWlCLEVBQ2IsTUFBTSxDQUFDLFFBQVEsRUFDZixNQUFNLENBQUMsb0JBQW9CLEVBQzNCLE1BQU0sQ0FBQyx3QkFBd0IsQ0FDbEMsQ0FBQztRQUNGLElBQUEseUNBQWlDLEdBQUUsQ0FBQztLQUN2QztTQUFNO1FBQ0gsSUFBQSw0Q0FBb0MsR0FBRSxDQUFDO0tBQzFDO0lBRUQsT0FBTyxPQUFPLENBQUM7QUFDbkIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsZUFBZSxDQUFDIn0=


// WEBPACK FOOTER //
// ../../../src/tracker/snowplowTracker.ts